import { IBusinessRuleService } from "../../service/evaluation/BusinessRuleService";
import { IBusinessRule } from "../../model/evaluation/BusinessRule";

export default class CreateBusinessRuleInteractor {
  private businessRuleService: IBusinessRuleService;

  constructor(businessRuleService) {
    this.businessRuleService = businessRuleService;
  }

  async execute(businessRule: IBusinessRule) {
    return this.businessRuleService.createBusinessRule(businessRule);
  }
}
